import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import React, { useState } from 'react';

export const MindmapSelection = ({
  style,
  className,
}: {
  style: React.CSSProperties | undefined;
  className: string | undefined;
}) => {
  const mindmapSelectItems = [
    { label: 'New York York York York York York York York York York York York', value: 'NY' },
    { label: 'Rome', value: 'RM' },
    { label: 'London', value: 'LDN' },
    { label: 'Istanbul', value: 'IST' },
    { label: 'Paris', value: 'PRS' },
  ];

  const [selectedMindmap, setSelectedMindmap] = useState(null);

  const filterTemplate = () => {
    return <Button label="Mindmap erstellen" style={{ width: '100% ' }} />;
  };

  return (
    <div className={'p-inputgroup ' + className} style={style}>
      <Dropdown
        filter
        filterTemplate={filterTemplate}
        value={selectedMindmap}
        options={mindmapSelectItems}
        onChange={e => setSelectedMindmap(e.value)}
        placeholder="Mindmap wählen"
      />
      <Button icon="pi pi-bars" className="p-button-secondary" />
    </div>
  );
};
